import React from 'react';
import { INavigationData } from '../EquipmentSlider/EquipmentSlider';
import styled from 'styled-components';

const EquipmentNav = ({ title, subtitle, className }: INavigationData) => {
  return (
    <EqupmentButton className={className}>
      <EqupmentButtonTitle>{title}</EqupmentButtonTitle>
      <EqupmentButtonSubTitle>{subtitle}</EqupmentButtonSubTitle>
    </EqupmentButton>
  );
};

const EqupmentButton = styled.button`
  border: 2px solid #e7e8eb;
  background: transparent;
  border-radius: 24px;
  width: 260.75px;
  height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 32px;
  @media (max-width: 599px) {
    width: 47%;
    padding: 12px 32px;
  }
`;

const EqupmentButtonTitle = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #26292d;
`;

const EqupmentButtonSubTitle = styled.span`
  font-weight: 400;
  font-size: 18px;
  margin-top: 7px;
  color: #26292d;
  @media (max-width: 599px) {
    margin-top: 5px;
  }
`;

export default EquipmentNav;
